import { render, staticRenderFns } from "./JoinDiscoveryBankModel.vue?vue&type=template&id=7b2abd87&scoped=true"
import script from "./JoinDiscoveryBankModel.vue?vue&type=script&lang=js"
export * from "./JoinDiscoveryBankModel.vue?vue&type=script&lang=js"
import style0 from "./JoinDiscoveryBankModel.vue?vue&type=style&index=0&id=7b2abd87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2abd87",
  null
  
)

export default component.exports